import { useState } from 'react';
import { Sheet } from './ui/Sheet';
import { Input } from './ui/Input';
import { Button } from './ui/Button';

const MIN_PASSWORD_LENGTH = 5;

export function ResetPasswordSheet({
  open,
  onClose,
  title,
  subtitle,
  labels,
  onSubmit,
  isLoading = false,
}) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleClose = () => {
    setNewPassword('');
    setConfirmPassword('');
    setError('');
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!newPassword || !confirmPassword) {
      setError(labels.resetPasswordFillAll);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(labels.resetPasswordMismatch);
      return;
    }
    if (newPassword.length < MIN_PASSWORD_LENGTH) {
      setError(labels.resetPasswordTooShort);
      return;
    }
    const ok = await onSubmit(newPassword);
    if (ok) handleClose();
  };

  return (
    <Sheet open={open} onClose={handleClose} title={title}>
      {subtitle && <p className="text-sm text-muted mb-4">{subtitle}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label={labels.newPassword}
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autoComplete="new-password"
        />
        <Input
          label={labels.confirmPassword}
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          autoComplete="new-password"
        />
        <p className="text-xs text-muted">{labels.resetPasswordHint}</p>
        {error && <p className="text-sm text-danger">{error}</p>}
        <div className="flex gap-2 justify-end">
          <Button type="button" variant="secondary" onClick={handleClose}>
            {labels.cancel}
          </Button>
          <Button type="submit" isLoading={isLoading}>
            {labels.resetPasswordSave}
          </Button>
        </div>
      </form>
    </Sheet>
  );
}
